var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-header-wrapper",
    [
      _c(
        "a-card",
        { attrs: { bordered: false } },
        [
          _c(
            "div",
            { staticClass: "table-page-search-wrapper" },
            [
              _c(
                "a-form",
                { attrs: { layout: "inline" } },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: 48 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { md: 8, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "设备编号", prop: "deviceId" } },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: "请输入设备编号",
                                  "allow-clear": "",
                                },
                                model: {
                                  value: _vm.queryParam.deviceId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryParam, "deviceId", $$v)
                                  },
                                  expression: "queryParam.deviceId",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { md: 8, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "工号", prop: "jobNumber" } },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: "请输入工号",
                                  "allow-clear": "",
                                },
                                model: {
                                  value: _vm.queryParam.jobNumber,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryParam, "jobNumber", $$v)
                                  },
                                  expression: "queryParam.jobNumber",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.advanced
                        ? [
                            _c(
                              "a-col",
                              { attrs: { md: 8, sm: 24 } },
                              [
                                _c(
                                  "a-form-item",
                                  { attrs: { label: "汇总日期" } },
                                  [
                                    _c("a-range-picker", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        valueFormat: "YYYY-MM-DD",
                                        format: "YYYY-MM-DD",
                                        "allow-clear": "",
                                      },
                                      model: {
                                        value: _vm.daterangeReportDate,
                                        callback: function ($$v) {
                                          _vm.daterangeReportDate = $$v
                                        },
                                        expression: "daterangeReportDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "a-col",
                              { attrs: { md: 8, sm: 24 } },
                              [
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      label: "时长不低于(秒)",
                                      prop: "timeSum",
                                    },
                                  },
                                  [
                                    _c("a-input", {
                                      attrs: {
                                        placeholder: "请输入时长(秒)",
                                        "allow-clear": "",
                                      },
                                      model: {
                                        value: _vm.beginTimeSum,
                                        callback: function ($$v) {
                                          _vm.beginTimeSum = $$v
                                        },
                                        expression: "beginTimeSum",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "a-col",
                              { attrs: { md: 8, sm: 24 } },
                              [
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      label: "里程不低于(米)",
                                      prop: "odoSum",
                                    },
                                  },
                                  [
                                    _c("a-input", {
                                      attrs: {
                                        placeholder: "请输入里程(米)",
                                        "allow-clear": "",
                                      },
                                      model: {
                                        value: _vm.beginOdoSum,
                                        callback: function ($$v) {
                                          _vm.beginOdoSum = $$v
                                        },
                                        expression: "beginOdoSum",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _c(
                        "a-col",
                        { attrs: { md: (!_vm.advanced && 8) || 24, sm: 24 } },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "table-page-search-submitButtons",
                              style:
                                (_vm.advanced && {
                                  float: "right",
                                  overflow: "hidden",
                                }) ||
                                {},
                            },
                            [
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.handleQuery },
                                },
                                [
                                  _c("a-icon", { attrs: { type: "search" } }),
                                  _vm._v("查询"),
                                ],
                                1
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  on: { click: _vm.resetQuery },
                                },
                                [
                                  _c("a-icon", { attrs: { type: "redo" } }),
                                  _vm._v("重置"),
                                ],
                                1
                              ),
                              _c(
                                "a",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  on: { click: _vm.toggleAdvanced },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.advanced ? "收起" : "展开") +
                                      " "
                                  ),
                                  _c("a-icon", {
                                    attrs: {
                                      type: _vm.advanced ? "up" : "down",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-toolbar",
            {
              attrs: { loading: _vm.loading, refresh: "", tid: "1" },
              on: { refreshQuery: _vm.getList },
            },
            [
              _c(
                "div",
                { staticClass: "table-operations" },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.isRunReport = true
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "play-circle" } }),
                      _vm._v("生成日报 "),
                    ],
                    1
                  ),
                  _c(
                    "a-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["tenant:jt808:employeeDailyReport:add"],
                          expression:
                            "['tenant:jt808:employeeDailyReport:add']",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.$refs.createForm.handleAdd()
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "plus" } }),
                      _vm._v("新增 "),
                    ],
                    1
                  ),
                  _c(
                    "a-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["tenant:jt808:employeeDailyReport:edit"],
                          expression:
                            "['tenant:jt808:employeeDailyReport:edit']",
                        },
                      ],
                      attrs: { type: "primary", disabled: _vm.single },
                      on: {
                        click: function ($event) {
                          return _vm.$refs.createForm.handleUpdate(
                            undefined,
                            _vm.ids
                          )
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "edit" } }),
                      _vm._v("修改 "),
                    ],
                    1
                  ),
                  _c(
                    "a-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["tenant:jt808:employeeDailyReport:export"],
                          expression:
                            "['tenant:jt808:employeeDailyReport:export']",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.handleExport },
                    },
                    [
                      _c("a-icon", { attrs: { type: "download" } }),
                      _vm._v("导出 "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c("create-form", { ref: "createForm", on: { ok: _vm.getList } }),
          _c("a-table", {
            attrs: {
              loading: _vm.loading,
              size: _vm.tableSize,
              rowKey: "id",
              tid: "1",
              columns: _vm.columns,
              "data-source": _vm.list,
              pagination: false,
            },
            scopedSlots: _vm._u([
              {
                key: "reportDate",
                fn: function (text, record) {
                  return _c("span", {}, [
                    _vm._v(
                      " " + _vm._s(_vm.parseTime(record.reportDate)) + " "
                    ),
                  ])
                },
              },
              {
                key: "toWorkTime",
                fn: function (text, record) {
                  return _c("span", {}, [
                    _vm._v(
                      " " + _vm._s(_vm.parseTime(record.toWorkTime)) + " "
                    ),
                  ])
                },
              },
              {
                key: "offWorkTime",
                fn: function (text, record) {
                  return _c("span", {}, [
                    _vm._v(
                      " " + _vm._s(_vm.parseTime(record.offWorkTime)) + " "
                    ),
                  ])
                },
              },
              {
                key: "operation",
                fn: function (text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      _c("a-divider", {
                        directives: [
                          {
                            name: "hasPermi",
                            rawName: "v-hasPermi",
                            value: ["tenant:jt808:employeeDailyReport:edit"],
                            expression:
                              "['tenant:jt808:employeeDailyReport:edit']",
                          },
                        ],
                        attrs: { type: "vertical" },
                      }),
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["tenant:jt808:employeeDailyReport:edit"],
                              expression:
                                "['tenant:jt808:employeeDailyReport:edit']",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.$refs.createForm.handleUpdate(
                                record,
                                undefined
                              )
                            },
                          },
                        },
                        [
                          _c("a-icon", { attrs: { type: "edit" } }),
                          _vm._v("修改 "),
                        ],
                        1
                      ),
                      _c("a-divider", {
                        directives: [
                          {
                            name: "hasPermi",
                            rawName: "v-hasPermi",
                            value: ["tenant:jt808:employeeDailyReport:remove"],
                            expression:
                              "['tenant:jt808:employeeDailyReport:remove']",
                          },
                        ],
                        attrs: { type: "vertical" },
                      }),
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: [
                                "tenant:jt808:employeeDailyReport:remove",
                              ],
                              expression:
                                "['tenant:jt808:employeeDailyReport:remove']",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.handleDelete(record)
                            },
                          },
                        },
                        [
                          _c("a-icon", { attrs: { type: "delete" } }),
                          _vm._v("删除 "),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                },
              },
            ]),
          }),
          _c("a-pagination", {
            staticClass: "ant-table-pagination",
            attrs: {
              "show-size-changer": "",
              "show-quick-jumper": "",
              current: _vm.queryParam.pageNum,
              total: _vm.total,
              "page-size": _vm.queryParam.pageSize,
              showTotal: function (total) {
                return "共 " + total + " 条"
              },
            },
            on: {
              showSizeChange: _vm.onShowSizeChange,
              change: _vm.changeSize,
            },
          }),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          staticClass: "daily-report",
          attrs: { title: "手动生成日报", visible: _vm.isRunReport },
          on: {
            ok: _vm.handleRunReportOk,
            cancel: function ($event) {
              _vm.isRunReport = false
            },
          },
        },
        [
          _c(
            "a-form-model-item",
            { attrs: { label: "统计日期" } },
            [
              _c("a-date-picker", {
                attrs: { format: "YYYY-MM-DD", "value-format": "YYYY-MM-DD" },
                model: {
                  value: _vm.runDate,
                  callback: function ($$v) {
                    _vm.runDate = $$v
                  },
                  expression: "runDate",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }